import { createReducer } from '@reduxjs/toolkit';

import { PoolSnackbarData } from '../components/snackbars/pool-snackbar';
import { enqueueSnackbar, removeSnackbar } from './snackbar-actions';

export interface SnackbarReducerState {
    notifications: PoolSnackbarData[];
}

const initialState: SnackbarReducerState = {
    notifications: [],
};

export const snackbarReducer = createReducer(initialState, builder => {
    builder.addCase(enqueueSnackbar, (state, action) => ({
        ...state,
        notifications: [
            ...state.notifications,
            // Only add to list if new key
            ...(state.notifications.map(n => n.key).includes(action.payload.key) ? [] : [action.payload]),
        ],
    }));
    builder.addCase(removeSnackbar, (state, action) => ({
        ...state,
        notifications: state.notifications.filter(notification => notification.key !== action.payload),
    }));
});
